import axios from 'axios';
import {
  API_BASE_LAB_ORDERS_URL,
  API_LAB_ORDERS_LIST,
  API_LAB_ORDERS_CREATE,
  API_LAB_ORDERS_DETAILS,
  API_LAB_ORDERS_BY_PATIENT,
  API_LAB_ORDERS_UPDATE_RESULTS
} from '../../../helpers/urlHelper';

// ========================================================================
// 🧪 SERVICIO DE ÓRDENES DE LABORATORIO ✅
// ========================================================================

class LaboratoryOrdersService {
  
  // Versión del servicio con logging detallado para debug
static async createOrder(orderData) {
  try {
    const url = `${API_BASE_LAB_ORDERS_URL}${API_LAB_ORDERS_CREATE}`;
    console.log('Making request to:', url);
    console.log('With data:', orderData);
    
    const response = await axios.post(url, orderData, {
      headers: {
        'Content-Type': 'application/json',
        // Agregar headers de autenticación si es necesario
        // 'Authorization': `Bearer ${token}`
      }
    });
    
    console.log('Response received:', response);
    return response.data;
    
  } catch (error) {
    console.error('Service error details:');
    console.error('Error object:', error);
    
    if (error.response) {
      // El servidor respondió con un código de error
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
      console.error('Response headers:', error.response.headers);
    } else if (error.request) {
      // La petición se hizo pero no se recibió respuesta
      console.error('No response received:', error.request);
    } else {
      // Error en la configuración de la petición
      console.error('Request config error:', error.message);
    }
    
    throw error;
  }
}

  // Obtener todas las órdenes de laboratorio
  static async getAllOrders(params = {}) {
    try {
      const response = await axios.get(
        `${API_BASE_LAB_ORDERS_URL}${API_LAB_ORDERS_LIST}`,
        { params }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching laboratory orders:', error);
      throw error;
    }
  }

  // Obtener orden por ID
  static async getOrderById(orderId) {
    try {
      const response = await axios.get(
        `${API_BASE_LAB_ORDERS_URL}${API_LAB_ORDERS_DETAILS}/${orderId}`
      );
      return response.data;
    } catch (error) {
      console.error(`Error fetching laboratory order ${orderId}:`, error);
      throw error;
    }
  }

  // Obtener órdenes por paciente
  static async getPatientOrders(patientId) {
    try {
      const response = await axios.get(
        `${API_BASE_LAB_ORDERS_URL}${API_LAB_ORDERS_BY_PATIENT}/${patientId}/orders`
      );
      return response.data;
    } catch (error) {
      console.error(`Error fetching orders for patient ${patientId}:`, error);
      throw error;
    }
  }

  // Actualizar resultados de orden
  static async updateOrderResults(orderId, resultsData) {
    try {
      const response = await axios.put(
        `${API_BASE_LAB_ORDERS_URL}${API_LAB_ORDERS_UPDATE_RESULTS}/${orderId}/results`,
        resultsData
      );
      return response.data;
    } catch (error) {
      console.error(`Error updating results for order ${orderId}:`, error);
      throw error;
    }
  }

  // Método adicional para obtener órdenes con filtros
  static async getOrdersWithFilters(filters) {
    try {
      const response = await axios.get(
        `${API_BASE_LAB_ORDERS_URL}${API_LAB_ORDERS_LIST}`,
        { 
          params: {
            ...filters,
            // Añadir parámetros comunes de filtrado
            page: filters.page || 1,
            limit: filters.limit || 10,
            sortBy: filters.sortBy || 'createdAt',
            sortOrder: filters.sortOrder || 'desc'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching filtered laboratory orders:', error);
      throw error;
    }
  }

  // Método para obtener estadísticas de órdenes
  static async getOrdersStats() {
    try {
      const response = await axios.get(
        `${API_BASE_LAB_ORDERS_URL}${API_LAB_ORDERS_LIST}/stats`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching laboratory orders stats:', error);
      throw error;
    }
  }
}

export default LaboratoryOrdersService;